var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcArrowRightFillDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.226 7.65344L5.77373 4.10542C5.46648 3.86057 5 4.06951 5 4.45198L5 11.548C5 11.9305 5.46648 12.1394 5.77373 11.8946L10.226 8.34656C10.4523 8.1662 10.4523 7.8338 10.226 7.65344Z",
    fill: "#2D2D2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowRightFillDark);
export default __webpack_public_path__ + "static/media/ic-arrow-right-fill-dark.fd553edbc47984c3f661a204ee658558.svg";
export { ForwardRef as ReactComponent };